var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tab_section"}},[_c('v-expand-transition',[(_vm.dataPresent)?_c('Tabs',{attrs:{"tabs":_vm.tabs,"colorTheme":"light"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }